export default __webpack_public_path__ + "static/media/KZ.M.04.2157.5d90a70a.svg";